import { Routes } from '@models/route';
import { lazy } from 'react';

const ListGallery = lazy(() =>
  import('@pages/gallery/list-gallery').then((p) => ({
    default: p.ListGallery
  }))
);

const AddImage = lazy(() =>
  import('@pages/gallery/add-image').then((p) => ({
    default: p.AddImage
  }))
);

export const GalleryRouter: Routes = [
  {
    path: '/gallery',
    component: ListGallery,
    children: [
      {
        path: 'add-image',
        component: AddImage
      }
    ]
  }
];
